import { OTPublisher } from 'opentok-react'
import React from 'react'

const Publisher = (props) => {
	return (
		<div style={{display: 'inline-block'}}>
			<div style={{ display: 'inline-block', border: '2px solid #333', borderRadius: 5 }}>
				<OTPublisher
					session={props.session}
					properties={props.properties}
					eventHandlers={props.publisherEventHandlers}
					onPublish={props.onPublish}
					onError={props.onError}
				/>
			</div>
				{props.videoSource === 'screen' &&
				<div style={{ display: 'inline-block', border: '2px solid #333', borderRadius: 5 }}>
					<OTPublisher
						className='screenSharing'
						session={props.session}
						eventHandlers={props.publisherEventHandlers}
						onPublish={props.onPublish}
						onError={props.onError}
						properties={{
							publishVideo: true,
							publishAudio: false,
							videoSource: 'screen',
							width: 150, height: 150,
						}}
					/>
				</div>
				}
			<div style={{ padding: '15px 0' }}>
				<button id="videoButton" onClick={props.toggleVideo}>
					{props.video ? 'Disable' : 'Enable'} Video
				</button>
				<button id="audioButton" onClick={props.toggleAudio}>
					{props.audio ? 'Disable' : 'Enable'} Audio
				</button>
				<button id="videoButton" onClick={props.toggleVideoSource}>
					{props.videoSource === 'camera' ? 'Share screen' : 'Disable screen sharing'}
				</button>
			</div>
		</div>
	)
}

export default Publisher



// WEBPACK FOOTER //
// ./src/Publisher.js